const Flag = ({ width = 28, height = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="27.5"
        height="19.5"
        rx="1.75"
        fill="white"
        stroke="#F5F5F5"
        strokeWidth="0.5"
      />
      <mask
        id="mask0_2002_3751"
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="20"
      >
        <rect
          x="0.25"
          y="0.25"
          width="27.5"
          height="19.5"
          rx="1.75"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
        />
      </mask>
      <g mask="url(#mask0_2002_3751)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.66667H28V0H0V6.66667Z"
          fill="#FFA44A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 20H28V13.3334H0V20Z"
          fill="#1A9F0B"
        />
        <path
          d="M14 12.3333C15.2887 12.3333 16.3333 11.2887 16.3333 10C16.3333 8.71134 15.2887 7.66667 14 7.66667C12.7113 7.66667 11.6667 8.71134 11.6667 10C11.6667 11.2887 12.7113 12.3333 14 12.3333Z"
          fill="#181A93"
          fillOpacity="0.15"
          stroke="#181A93"
          strokeWidth="0.666667"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9997 10.6667C14.3679 10.6667 14.6663 10.3682 14.6663 10C14.6663 9.63185 14.3679 9.33337 13.9997 9.33337C13.6315 9.33337 13.333 9.63185 13.333 10C13.333 10.3682 13.6315 10.6667 13.9997 10.6667Z"
          fill="#181A93"
        />
      </g>
    </svg>
  );
};

export default Flag;
